import { render, staticRenderFns } from "./NotificationPage.vue?vue&type=template&id=11a54648&scoped=true&"
import script from "./NotificationPage.vue?vue&type=script&lang=js&"
export * from "./NotificationPage.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPage.vue?vue&type=style&index=0&id=11a54648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a54648",
  null
  
)

export default component.exports